import WebSocketStore from 'core/classes/services/WebSocketStore'
import { TOnboardingUser } from 'onboarding/classes/models/onboardingUser'

class UserApi {
  public async fetchMany(text: string) {
    const wsClient = WebSocketStore.get('onboarding')
    const response = await wsClient.call<{ items: TOnboardingUser[] }>({
      service: 'application-user',
      action: 'search-by-login',
      payload: {
        query: text,
      },
      isAuth: true,
      returnError: true,
    })
    if (response.status !== 'success') {
      throw new Error(response.message || 'Failed to fetch users')
    }

    return response.data.items
  }
}

export const userApi = new UserApi()
